import api from '..'

export interface MarketingSpendPayload {
  spend_date: string
  affiliate_id: number
  ad_spend: number
  creative_spend: number
}

export async function createMarketingSpend(
  spends: MarketingSpendPayload[],
): Promise<void> {
  await api.post('/marketing-spend', { spends })
}
